module.exports = __webpack_public_path__ + "static/media/hcm-district3.77875801.svg";